import { render } from "./edit-employee-modal.vue?vue&type=template&id=5d176530&scoped=true"
import script from "./edit-employee-modal.vue?vue&type=script&lang=js"
export * from "./edit-employee-modal.vue?vue&type=script&lang=js"

import "./edit-employee-modal.vue?vue&type=style&index=0&id=5d176530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d176530"]])

export default __exports__